<template>
  <div>
    
  </div>
</template>


<script>
  import axios from 'axios';
  import Swal from 'sweetalert2';

export default {
  data: function () {
      return {
          registerBtn: "Login",
          verifyBtn: "Verify",
          resendBtn: "Resend OTP",
          changeBtn: "Change email address",
          disabledClass: "",
          disabledChange: "",
          isActive: false,
          email: "",
          errors: [],
          registered: false,
          registered_email: "",
          code1: "",
          code2: "",
          code3: "",
          code4: "",
          code: "",
          device_identifier: "TAPWEBIDENTIFIER",
          device_type: "pc",
          fcm_token: "7155",
          loadingMessage: 'Verifying account',
          isAuthenticated: false,
          msalInstance: null,
          device_info: "BROWSER",
      };
  },

  mounted() {

      var bodyFormData = new FormData();
      this.code = this.$route.query.code;
      bodyFormData.append('code', this.code);

      axios({
          method: "post",
          data: bodyFormData,
          url: this.baseAPIURL+"/apiv3/microsoft365Callback",
          headers: {
              "Content-Type": "multipart/form-data"
          },
      })
      .then(response => {
          console.log(response);

           if (response.data.data.result == "success") {
                    this.isActive = false; //disable the button
                    this.disabledClass = "";
                    this.disabledChange = "";
                    this.disabledResend = "";
                    this.verifyBtn = "Verify";
                    this.loadingMessage = "Loading theme";

                    Swal.update({
                    html: `<small>${this.loadingMessage}</small>`,
                  });

                        var themeData = new FormData();
                        themeData.append("email", response.data.data.email);

                        axios({
                              method: "post",
                              url: this.baseAPIURL+"/apiv3/theme.json",
                              data: themeData,
                              headers: {
                                  "auth": response.data.data.token,
                                  "Content-Type": "multipart/form-data",
                              },
                          })
                          .then(themeresponse => {
                            this.$store.dispatch("verify", {
                                  "email": response.data.data.email,
                                  "token": response.data.data.token,
                                  "user_guid": response.data.data.guid,
                            });

                            this.$store.dispatch("updateNewLoad", true);

                              Swal.close();

                              this.$store.dispatch("updateTheme", themeresponse.data.theme[0].web_main_page_icon);

                            response.data.data.data.book_code.map((item, index) => {
                                  if (index === 0) {
                                      if (this.$store.getters.selected_book == ""){    
                                          this.$store.dispatch('activeBook', item.code);
                                          this.$store.dispatch('activeBookDesc', item.description);
                                          this.$store.dispatch('setPages', item.pages);
                                      }
                                        this.$store.dispatch("setBooks", item.code);
                                        this.$store.dispatch("setActiveBooks", item.code);
                                        this.$store.dispatch("setSelectedBookModDate", item.modified);
                                    }else{
                                        this.$store.dispatch("setBooks", item.code);
                                        this.$store.dispatch("setActiveBooks", item.code);
                                        this.$store.dispatch("setSelectedBookModDate", item.modified);
                                    }
                                  
                                    if (/@cloudstaff.com\s*$/.test(this.email)) {
                                        this.$store.dispatch("setCS", true);
                                    } else {
                                        this.$store.dispatch("setCS", false);
                                  }
                              }); 

                               this.$moshaToast("Welcome!", { type: "success" });
                              this.$router.push("/dashboard");
                          })


                  


                  

                 
           }

      });

  },
  methods: {
    unqid() {
        var timestamp = Date.now();
        var randomNum = Math.floor(Math.random() * 100000); 
        var uniqueid = `${timestamp}${randomNum}`;
        return uniqueid;
    },
  },    
}


</script>